import { render, staticRenderFns } from "./CostSectionParallax.vue?vue&type=template&id=9b70dfbc&"
import script from "./CostSectionParallax.vue?vue&type=script&lang=js&"
export * from "./CostSectionParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VLayout,VParallax})
